var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImg4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 613.22 657.54",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{isolation:isolate;}.cls-2{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4173",
    "data-name": "Group 4173"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2642",
    "data-name": "Group 2642"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2526",
    "data-name": "Group 2526"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Exports_to_5_Countries",
    "data-name": "Exports to 5 Countries",
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M-1285.22,4711.3h-28.5v23.31h33.11v7.09h-41.79v-65.76h41.33V4683h-32.65v21.18h28.5Z",
    transform: "translate(1384.04 -4216.11)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M-1245.48,4710.67l10.84-17.84h9.76l-16,24.17,16.48,24.7H-1234l-11.3-18.29-11.29,18.29h-9.71l16.49-24.7-16-24.17h9.66Z",
    transform: "translate(1384.04 -4216.11)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M-1165.5,4717.81q0,11.16-5.1,18a16.37,16.37,0,0,1-13.82,6.82q-8.89,0-14-5.65v23.53h-8.36v-67.66h7.63l.41,5.42q5.1-6.33,14.18-6.32a16.66,16.66,0,0,1,13.94,6.64q5.13,6.63,5.12,18.47Zm-8.35-1q0-8.26-3.52-13A11.35,11.35,0,0,0-1187,4699a12.27,12.27,0,0,0-11.38,6.73v23.35a12.3,12.3,0,0,0,11.47,6.69,11.29,11.29,0,0,0,9.55-4.77Q-1173.84,4726.25-1173.85,4716.86Z",
    transform: "translate(1384.04 -4216.11)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M-1147.84,4716.81a28.87,28.87,0,0,1,2.82-12.91,21,21,0,0,1,7.86-8.86,21.38,21.38,0,0,1,11.5-3.11q10,0,16.14,6.91t6.17,18.38v.59a29.11,29.11,0,0,1-2.73,12.8,20.75,20.75,0,0,1-7.82,8.83,21.63,21.63,0,0,1-11.67,3.17q-9.95,0-16.11-6.91t-6.16-18.3Zm8.4,1q0,8.13,3.77,13a12.08,12.08,0,0,0,10.1,4.93,12,12,0,0,0,10.11-5q3.75-5,3.75-14,0-8-3.81-13a12.17,12.17,0,0,0-10.14-5,12,12,0,0,0-10,4.93Q-1139.45,4708.64-1139.44,4717.81Z",
    transform: "translate(1384.04 -4216.11)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M-1060,4700.33a25,25,0,0,0-4.11-.32q-8.22,0-11.15,7v34.69h-8.36v-48.87h8.13l.14,5.65a13,13,0,0,1,11.65-6.55,8.52,8.52,0,0,1,3.7.63Z",
    transform: "translate(1384.04 -4216.11)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M-1029.47,4681v11.83h9.12v6.46h-9.12v30.35a6.8,6.8,0,0,0,1.22,4.41c.81,1,2.2,1.46,4.15,1.46a20.32,20.32,0,0,0,4-.54v6.74a24.34,24.34,0,0,1-6.41.9c-3.74,0-6.55-1.13-8.45-3.39s-2.85-5.47-2.85-9.62v-30.31h-8.9v-6.46h8.9V4681Z",
    transform: "translate(1384.04 -4216.11)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M-972.88,4728.74a6.15,6.15,0,0,0-2.55-5.26q-2.57-1.87-8.9-3.23a42.77,42.77,0,0,1-10.08-3.25,14.48,14.48,0,0,1-5.51-4.52,10.82,10.82,0,0,1-1.78-6.23,12.68,12.68,0,0,1,5.08-10.17q5.08-4.15,13-4.15,8.31,0,13.48,4.29a13.62,13.62,0,0,1,5.17,11h-8.4a7.54,7.54,0,0,0-2.91-5.91,10.9,10.9,0,0,0-7.34-2.49,11.41,11.41,0,0,0-7.14,2,6.24,6.24,0,0,0-2.57,5.19,5.07,5.07,0,0,0,2.39,4.57q2.4,1.53,8.65,2.93a45.67,45.67,0,0,1,10.14,3.34,14.87,14.87,0,0,1,5.76,4.68,11.48,11.48,0,0,1,1.87,6.66,12.48,12.48,0,0,1-5.24,10.5q-5.24,4-13.59,4a24.67,24.67,0,0,1-10.39-2.08,16.9,16.9,0,0,1-7.07-5.81,14,14,0,0,1-2.55-8.06H-995a8.69,8.69,0,0,0,3.37,6.66,13,13,0,0,0,8.29,2.47,13.47,13.47,0,0,0,7.61-1.92A5.91,5.91,0,0,0-972.88,4728.74Z",
    transform: "translate(1384.04 -4216.11)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M-900.9,4681v11.83h9.13v6.46h-9.13v30.35a6.8,6.8,0,0,0,1.22,4.41c.81,1,2.2,1.46,4.16,1.46a20.33,20.33,0,0,0,4-.54v6.74a24.34,24.34,0,0,1-6.41.9c-3.74,0-6.55-1.13-8.45-3.39s-2.85-5.47-2.85-9.62v-30.31h-8.89v-6.46h8.89V4681Z",
    transform: "translate(1384.04 -4216.11)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M-875.88,4716.81a28.87,28.87,0,0,1,2.82-12.91,21,21,0,0,1,7.86-8.86,21.37,21.37,0,0,1,11.49-3.11q10,0,16.15,6.91t6.17,18.38v.59a29.11,29.11,0,0,1-2.73,12.8,20.75,20.75,0,0,1-7.82,8.83,21.64,21.64,0,0,1-11.68,3.17q-9.93,0-16.1-6.91t-6.16-18.3Zm8.4,1q0,8.13,3.77,13a12.07,12.07,0,0,0,10.09,4.93,12,12,0,0,0,10.12-5q3.75-5,3.75-14,0-8-3.82-13a12.14,12.14,0,0,0-10.14-5,12,12,0,0,0-10,4.93Q-867.48,4708.64-867.48,4717.81Z",
    transform: "translate(1384.04 -4216.11)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M-1381.69,4839.78l3.34-32.79h33.7v7.72h-26.61l-2,17.93a21.29,21.29,0,0,1,11-2.84q9,0,14.27,5.94t5.29,16.05q0,10.17-5.49,16t-15.34,5.85q-8.71,0-14.22-4.84t-6.28-13.37h7.9q.77,5.66,4,8.52a12.51,12.51,0,0,0,8.58,2.87,11.27,11.27,0,0,0,9.15-4q3.32-4,3.32-11,0-6.6-3.59-10.6a12.22,12.22,0,0,0-9.55-4c-3.65,0-6.51.79-8.59,2.39l-2.21,1.81Z",
    transform: "translate(1384.04 -4216.11)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M-1299.54,4837.48h18.34v7.9h-18.34v20.78h-8.4v-20.78h-18.34v-7.9h18.34v-19.2h8.4Z",
    transform: "translate(1384.04 -4216.11)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M-1179.95,4851.89q-1.21,10.43-7.7,16.1t-17.23,5.67q-11.65,0-18.68-8.36t-7-22.36v-6.32a37.53,37.53,0,0,1,3.27-16.13,24.48,24.48,0,0,1,9.28-10.68,25.92,25.92,0,0,1,13.92-3.73q10.47,0,16.8,5.85t7.36,16.2h-8.72q-1.12-7.89-4.9-11.42t-10.54-3.54q-8.31,0-13,6.15t-4.72,17.5v6.37q0,10.73,4.48,17.05a14.44,14.44,0,0,0,12.51,6.33q7.23,0,11.09-3.28t5.12-11.4Z",
    transform: "translate(1384.04 -4216.11)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M-1162.39,4847.87a28.88,28.88,0,0,1,2.83-12.92,21,21,0,0,1,7.86-8.86,21.44,21.44,0,0,1,11.49-3.11q10,0,16.15,6.91t6.17,18.38v.59a29,29,0,0,1-2.74,12.81,20.78,20.78,0,0,1-7.81,8.83,21.72,21.72,0,0,1-11.68,3.16q-9.93,0-16.1-6.91t-6.17-18.3Zm8.41,1q0,8.13,3.77,13.05a12,12,0,0,0,10.09,4.93,12,12,0,0,0,10.12-5q3.75-5,3.75-14,0-8-3.82-13a12.14,12.14,0,0,0-10.14-5,12,12,0,0,0-10,4.93Q-1154,4839.69-1154,4848.86Z",
    transform: "translate(1384.04 -4216.11)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M-1068,4867.92q-4.87,5.74-14.32,5.74-7.82,0-11.9-4.54t-4.13-13.44v-31.8h8.35v31.57q0,11.11,9,11.12,9.57,0,12.73-7.14v-35.55h8.36v48.87h-8Z",
    transform: "translate(1384.04 -4216.11)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M-1030,4823.88l.27,6.14a17.81,17.81,0,0,1,14.63-7q15.5,0,15.63,17.48v32.29h-8.35v-32.34q0-5.28-2.42-7.81t-7.38-2.53a12,12,0,0,0-7.14,2.17,14.62,14.62,0,0,0-4.79,5.69v34.82h-8.36v-48.87Z",
    transform: "translate(1384.04 -4216.11)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M-966.29,4812.05v11.83h9.13v6.46h-9.13v30.35a6.8,6.8,0,0,0,1.22,4.41c.82,1,2.2,1.47,4.16,1.47a20.4,20.4,0,0,0,4-.55v6.74a24.22,24.22,0,0,1-6.41.9q-5.6,0-8.45-3.39t-2.84-9.62v-30.31h-8.9v-6.46h8.9v-11.83Z",
    transform: "translate(1384.04 -4216.11)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M-914.53,4831.38a25.11,25.11,0,0,0-4.11-.32q-8.22,0-11.16,7v34.69h-8.35v-48.87H-930l.13,5.65a13,13,0,0,1,11.66-6.55,8.55,8.55,0,0,1,3.7.63Z",
    transform: "translate(1384.04 -4216.11)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M-897.56,4810.92a5,5,0,0,1,1.25-3.44,4.66,4.66,0,0,1,3.68-1.4,4.74,4.74,0,0,1,3.7,1.4,5,5,0,0,1,1.27,3.44,4.77,4.77,0,0,1-1.27,3.38,4.8,4.8,0,0,1-3.7,1.36,4.71,4.71,0,0,1-3.68-1.36A4.8,4.8,0,0,1-897.56,4810.92Zm9,61.83h-8.36v-48.87h8.36Z",
    transform: "translate(1384.04 -4216.11)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M-845.62,4873.66q-9.93,0-16.17-6.53t-6.23-17.46v-1.53a29.37,29.37,0,0,1,2.77-13,21.75,21.75,0,0,1,7.77-8.94,19.5,19.5,0,0,1,10.82-3.23q9.54,0,14.82,6.28t5.28,18v3.48h-33.11q.18,7.23,4.23,11.68a13.28,13.28,0,0,0,10.27,4.45,14.61,14.61,0,0,0,7.5-1.81,18.78,18.78,0,0,0,5.38-4.79l5.1,4Q-833.34,4873.66-845.62,4873.66Zm-1-43.82a11.16,11.16,0,0,0-8.49,3.68q-3.44,3.69-4.25,10.33h24.49v-.64q-.37-6.36-3.44-9.87A10.51,10.51,0,0,0-846.66,4829.84Z",
    transform: "translate(1384.04 -4216.11)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M-779.18,4859.79a6.13,6.13,0,0,0-2.56-5.26q-2.55-1.87-8.89-3.23a42.77,42.77,0,0,1-10.08-3.25,14.39,14.39,0,0,1-5.51-4.52,10.79,10.79,0,0,1-1.78-6.23,12.68,12.68,0,0,1,5.08-10.17q5.08-4.16,13-4.15,8.31,0,13.48,4.29a13.62,13.62,0,0,1,5.17,11h-8.4a7.54,7.54,0,0,0-2.91-5.91,10.92,10.92,0,0,0-7.34-2.49,11.39,11.39,0,0,0-7.14,2,6.26,6.26,0,0,0-2.58,5.19,5.08,5.08,0,0,0,2.4,4.57c1.59,1,4.48,2,8.65,2.93a45.12,45.12,0,0,1,10.14,3.35,14.76,14.76,0,0,1,5.76,4.67,11.48,11.48,0,0,1,1.87,6.66,12.51,12.51,0,0,1-5.24,10.51q-5.23,3.95-13.59,3.95a24.67,24.67,0,0,1-10.39-2.08,17,17,0,0,1-7.07-5.8,14,14,0,0,1-2.55-8.07h8.35a8.69,8.69,0,0,0,3.37,6.67,13,13,0,0,0,8.29,2.46,13.47,13.47,0,0,0,7.61-1.92A5.91,5.91,0,0,0-779.18,4859.79Z",
    transform: "translate(1384.04 -4216.11)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "trip"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_380",
    "data-name": "Path 380",
    className: "cls-2",
    d: "M-1243.49,4401.2l-11.62.77c.27,3.95.68,7.93,1.22,11.85l11.57-1.6c-.51-3.65-.9-7.41-1.16-11.06Z",
    transform: "translate(1384.04 -4216.11)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_381",
    "data-name": "Path 381",
    className: "cls-2",
    d: "M-1225.84,4315.57l-10.35-5.34c-1.82,3.49-3.53,7.15-5.11,10.8l10.7,4.62C-1229.12,4322.24-1227.51,4318.85-1225.84,4315.57Z",
    transform: "translate(1384.04 -4216.11)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_382",
    "data-name": "Path 382",
    className: "cls-2",
    d: "M-1240.45,4423.08l-11.4,2.4c.82,3.86,1.75,7.77,2.84,11.57l11.21-3.17c-1-3.55-1.89-7.17-2.65-10.79Z",
    transform: "translate(1384.04 -4216.11)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_383",
    "data-name": "Path 383",
    className: "cls-2",
    d: "M-1240.59,4357.17l-11.41-2.31c-.77,3.85-1.45,7.82-2,11.76l11.57,1.54c.48-3.67,1.11-7.37,1.85-11Z",
    transform: "translate(1384.04 -4216.11)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_384",
    "data-name": "Path 384",
    className: "cls-2",
    d: "M-1214.28,4296.66l-9.53-6.7c-2.27,3.23-4.47,6.59-6.52,10l10,6c1.91-3.18,4-6.31,6.09-9.32Z",
    transform: "translate(1384.04 -4216.11)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_385",
    "data-name": "Path 385",
    className: "cls-2",
    d: "M-1234.65,4335.87l-11-3.85c-1.32,3.75-2.52,7.57-3.58,11.38l11.23,3.08c1-3.54,2.09-7.11,3.33-10.62Z",
    transform: "translate(1384.04 -4216.11)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_386",
    "data-name": "Path 386",
    className: "cls-2",
    d: "M-1243.53,4379.07l-11.65-.77c-.24,3.82-.36,7.66-.36,11.54v.37l11.65-.37q0-5.39.36-10.79Z",
    transform: "translate(1384.04 -4216.11)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_387",
    "data-name": "Path 387",
    className: "cls-2",
    d: "M-1234.42,4444.36l-11,3.92c1.35,3.74,2.82,7.47,4.39,11.07l10.68-4.63c-1.47-3.37-2.85-6.84-4.11-10.33Z",
    transform: "translate(1384.04 -4216.11)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_388",
    "data-name": "Path 388",
    className: "cls-2",
    d: "M-1200.29,4279.48l-8.52-7.92c-2.7,2.91-5.33,5.93-7.81,9l9,7.34c2.31-2.86,4.78-5.7,7.29-8.41Z",
    transform: "translate(1384.04 -4216.11)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_389",
    "data-name": "Path 389",
    className: "cls-2",
    d: "M-1104.37,4229.33l-1.63-11.56c-3.91.54-7.86,1.23-11.75,2l2.39,11.41C-1111.72,4230.48-1108,4229.84-1104.37,4229.33Z",
    transform: "translate(1384.04 -4216.11)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_390",
    "data-name": "Path 390",
    className: "cls-2",
    d: "M-1082.33,4227.76l-.05-11.65c-4,0-8,.16-11.91.44l.83,11.65C-1089.78,4227.9-1086.07,4227.76-1082.33,4227.76Z",
    transform: "translate(1384.04 -4216.11)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_391",
    "data-name": "Path 391",
    className: "cls-2",
    d: "M-1126.06,4233.9l-3.16-11.21c-3.8,1.07-7.62,2.31-11.36,3.64l3.93,11c3.49-1.26,7.05-2.39,10.58-3.39Z",
    transform: "translate(1384.04 -4216.11)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_392",
    "data-name": "Path 392",
    className: "cls-2",
    d: "M-1184.4,4264.59l-7.37-9c-3.08,2.5-6.08,5.15-9,7.85l8,8.48c2.69-2.53,5.51-5,8.36-7.33Z",
    transform: "translate(1384.04 -4216.11)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_393",
    "data-name": "Path 393",
    className: "cls-2",
    d: "M-1146.81,4241.41l-4.62-10.67c-3.6,1.54-7.22,3.31-10.74,5.15l5.39,10.31c3.27-1.72,6.64-3.31,10-4.8Z",
    transform: "translate(1384.04 -4216.11)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_394",
    "data-name": "Path 394",
    className: "cls-2",
    d: "M-1166.38,4251.7l-6.09-9.93c-3.38,2.07-6.72,4.29-9.94,6.57l6.75,9.49c3-2.12,6.13-4.2,9.26-6.16Z",
    transform: "translate(1384.04 -4216.11)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_395",
    "data-name": "Path 395",
    className: "cls-2",
    d: "M-1017.18,4538.36l4.62,10.68c3.63-1.54,7.24-3.31,10.74-5.13l-5.36-10.33c-3.28,1.7-6.66,3.31-10,4.78Z",
    transform: "translate(1384.04 -4216.11)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_396",
    "data-name": "Path 396",
    className: "cls-2",
    d: "M-963.64,4500.41l8.48,7.95c2.7-2.91,5.34-5.91,7.83-9l-9-7.35c-2.31,2.86-4.8,5.68-7.32,8.38Z",
    transform: "translate(1384.04 -4216.11)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_397",
    "data-name": "Path 397",
    className: "cls-2",
    d: "M-979.56,4515.27l7.35,9c3.09-2.5,6.08-5.14,9-7.84l-7.95-8.48C-973.9,4510.5-976.69,4512.92-979.56,4515.27Z",
    transform: "translate(1384.04 -4216.11)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_398",
    "data-name": "Path 398",
    className: "cls-2",
    d: "M-949.59,4483.25l9.51,6.74c2.32-3.23,4.49-6.58,6.55-10l-10-6.05C-945.39,4477.11-947.45,4480.27-949.59,4483.25Z",
    transform: "translate(1384.04 -4216.11)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_399",
    "data-name": "Path 399",
    className: "cls-2",
    d: "M-997.6,4528.11l6.05,9.94c3.37-2.06,6.72-4.26,9.95-6.55l-6.73-9.5C-991.34,4524.13-994.42,4526.19-997.6,4528.11Z",
    transform: "translate(1384.04 -4216.11)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_400",
    "data-name": "Path 400",
    className: "cls-2",
    d: "M-1038,4545.82l3.15,11.22c3.8-1.07,7.63-2.32,11.36-3.61l-3.92-11C-1030.9,4543.71-1034.44,4544.82-1038,4545.82Z",
    transform: "translate(1384.04 -4216.11)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_401",
    "data-name": "Path 401",
    className: "cls-2",
    d: "M-920.16,4400.9l11.62.77c.27-3.95.4-8,.4-11.91h-11.65C-919.79,4393.5-919.91,4397.22-920.16,4400.9Z",
    transform: "translate(1384.04 -4216.11)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_402",
    "data-name": "Path 402",
    className: "cls-2",
    d: "M-923.16,4422.79l11.41,2.31c.78-3.85,1.48-7.82,2-11.74l-11.57-1.55c-.5,3.7-1.13,7.39-1.88,11Z",
    transform: "translate(1384.04 -4216.11)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_403",
    "data-name": "Path 403",
    className: "cls-2",
    d: "M-929.14,4444.08l11,3.89c1.34-3.75,2.55-7.57,3.61-11.36l-11.22-3.13C-926.78,4437-927.9,4440.58-929.14,4444.08Z",
    transform: "translate(1384.04 -4216.11)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_404",
    "data-name": "Path 404",
    className: "cls-2",
    d: "M-938,4464.39l10.34,5.4c1.82-3.5,3.54-7.14,5.12-10.8l-10.67-4.62C-934.7,4457.71-936.31,4461.09-938,4464.39Z",
    transform: "translate(1384.04 -4216.11)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_405",
    "data-name": "Path 405",
    className: "cls-2",
    d: "M-1225.52,4464.6l-10.32,5.39c1.84,3.5,3.81,7,5.87,10.36l10-6.07C-1222,4471.12-1223.8,4467.87-1225.52,4464.6Z",
    transform: "translate(1384.04 -4216.11)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_406",
    "data-name": "Path 406",
    className: "cls-2",
    d: "M-1191.29,4524.5c3.08,2.51,6.28,4.93,9.51,7.2l6.7-9.54q-4.56-3.21-8.89-6.72Z",
    transform: "translate(1384.04 -4216.11)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_407",
    "data-name": "Path 407",
    className: "cls-2",
    d: "M-1150.87,4549.18c3.61,1.54,7.35,3,11.12,4.37l3.85-11c-3.49-1.25-7-2.62-10.36-4.08Z",
    transform: "translate(1384.04 -4216.11)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_408",
    "data-name": "Path 408",
    className: "cls-2",
    d: "M-1171.93,4538.22c3.4,2.07,6.94,4,10.41,5.82l5.35-10.35c-3.27-1.69-6.54-3.52-9.72-5.45Z",
    transform: "translate(1384.04 -4216.11)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_409",
    "data-name": "Path 409",
    className: "cls-2",
    d: "M-1208.38,4508.24c2.72,2.91,5.56,5.73,8.43,8.42l7.94-8.53c-2.69-2.51-5.34-5.15-7.88-7.86Z",
    transform: "translate(1384.04 -4216.11)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_410",
    "data-name": "Path 410",
    className: "cls-2",
    d: "M-1213.91,4483.44l-9.51,6.73c2.31,3.23,4.72,6.4,7.22,9.48l9-7.38C-1209.54,4489.42-1211.79,4486.45-1213.91,4483.44Z",
    transform: "translate(1384.04 -4216.11)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_411",
    "data-name": "Path 411",
    className: "cls-2",
    d: "M-1059.63,4550.34l1.54,11.56c3.91-.54,7.86-1.21,11.75-2l-2.37-11.4C-1052.31,4549.2-1056,4549.84-1059.63,4550.34Z",
    transform: "translate(1384.04 -4216.11)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_412",
    "data-name": "Path 412",
    className: "cls-2",
    d: "M-1105.31,4561.93c3.89.52,7.89.93,11.86,1.16l.77-11.64c-3.73-.25-7.45-.63-11.07-1.12Z",
    transform: "translate(1384.04 -4216.11)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_413",
    "data-name": "Path 413",
    className: "cls-2",
    d: "M-1081.7,4551.86v11.67c4,0,8-.14,11.92-.41l-.77-11.65Q-1076.08,4551.86-1081.7,4551.86Z",
    transform: "translate(1384.04 -4216.11)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_414",
    "data-name": "Path 414",
    className: "cls-2",
    d: "M-1128.51,4557.13c3.85,1.06,7.7,2,11.56,2.8l2.31-11.41c-3.61-.77-7.24-1.61-10.79-2.6Z",
    transform: "translate(1384.04 -4216.11)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_415",
    "data-name": "Path 415",
    className: "cls-2",
    d: "M-926.89,4332.28a11.64,11.64,0,0,1,0,16.47,11.64,11.64,0,0,1-16.47,0l-8.21-8.21-12.33,20.56-4.84-4.84a11.46,11.46,0,0,1-3.43-8.21v-28.11l-28.82-28.83-20.56,53.51-5-4.95a23.36,23.36,0,0,1-6.75-17.81l3.5-59.57-20.56-20.61a11.6,11.6,0,0,1,0-16.42,11.6,11.6,0,0,1,16.42,0l20.58,20.58,59.57-3.49A23.31,23.31,0,0,1-936,4249.1l5,5-53.5,20.56,28.82,28.82h28.12a11.42,11.42,0,0,1,8.21,3.44l4.84,4.83-20.56,12.34Z",
    transform: "translate(1384.04 -4216.11)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_416",
    "data-name": "Path 416",
    className: "cls-2",
    d: "M-1109.54,4488.29a5.79,5.79,0,0,0,4.12-1.7l16.47-16.47a5.82,5.82,0,0,0,1.7-4.12v-26.9a5.79,5.79,0,0,0-.82-3l-12.41-20.76a5.83,5.83,0,0,0-5-2.76h-16.35a5.82,5.82,0,0,0-4.84,2.59l-6.46,9.69a11.64,11.64,0,0,1-9.69,5.19h-14.38v11.12a17.4,17.4,0,0,1-8,14.65l-17.79,11.46a129.3,129.3,0,0,0,36.32,32.2l12.42-8.3a17.51,17.51,0,0,1,9.7-2.94Z",
    transform: "translate(1384.04 -4216.11)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_417",
    "data-name": "Path 417",
    className: "cls-2",
    d: "M-1080.85,4262.7a129.25,129.25,0,0,0-23.47,2.18l.1,8.48a17.35,17.35,0,0,1-8.48,15.07l-14.64,8.73a5.74,5.74,0,0,0-2.36,7.23l10,23.13a17.28,17.28,0,0,1-5.15,20.36l-19,15a17.55,17.55,0,0,1-10.9,3.77h-11.5l7.42,25.72a11.5,11.5,0,0,1-1.9,10.15,11.7,11.7,0,0,1-9.32,4.62h-6.16a11.57,11.57,0,0,1-10.42-6.36l-6.81-13.53a5.78,5.78,0,0,0-5.21-3.22h-10.1c-.09,1.92-.15,3.85-.15,5.78a125.65,125.65,0,0,0,19.93,68l18.16-11.64a5.76,5.76,0,0,0,2.67-4.85v-11.06a11.55,11.55,0,0,1,11.56-11.56h14.44l6.48-9.61a17.47,17.47,0,0,1,14.53-7.71h16.3a17.61,17.61,0,0,1,14.93,8.33l12.44,20.64a17.16,17.16,0,0,1,2.47,8.88v26.69a17.16,17.16,0,0,1-5.12,12.27l-16.46,16.34a17.44,17.44,0,0,1-12.34,5.08h-14.94a5.86,5.86,0,0,0-3.23,1l-7.14,4.74a128.52,128.52,0,0,0,117.11-5.26l-9.49-15.38a28.54,28.54,0,0,1-1.22-28l2.66-5.25a17.37,17.37,0,0,1,15.61-9.58h8.21a5.78,5.78,0,0,0,5.4-3.63l7.89-19.56a5.78,5.78,0,0,0,.41-2.14v-12.73l-7-6.93-14.33,7.1a17.67,17.67,0,0,1-15.63,0l-23.29-11.56a17.23,17.23,0,0,1-9.63-15.49v-16A17.41,17.41,0,0,1-1075,4343.6h0v-5.78a17.4,17.4,0,0,1,7-13.88l33-27,1.49-25.16A127.93,127.93,0,0,0-1080.85,4262.7Z",
    transform: "translate(1384.04 -4216.11)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_418",
    "data-name": "Path 418",
    className: "cls-2",
    d: "M-972.19,4360a17.3,17.3,0,0,1-5.12-12.34V4322l-20.82-20.75-20.57,53.52-11.29-11.29a29.11,29.11,0,0,1-8.48-22.3l.54-9.16-25.13,20.66a5.85,5.85,0,0,0-2.31,4.63v5.82a5.83,5.83,0,0,0,5.82,5.82h0a11.66,11.66,0,0,1,11.65,11.65v16.1a5.78,5.78,0,0,0,3.22,5.2l23.29,11.65a5.8,5.8,0,0,0,5.2,0l14.33-7.17a11.65,11.65,0,0,1,13.45,2.18l7,7a11.58,11.58,0,0,1,3.39,8.23v12.8a17.15,17.15,0,0,1-1.25,6.49l-7.88,19.71a17.38,17.38,0,0,1-16.18,11h-8.21a5.82,5.82,0,0,0-5.21,3.22l-2.64,5.29a17.35,17.35,0,0,0,.77,17l9.38,15.31a127.61,127.61,0,0,0,51.65-131.82l-4.45,7.41Z",
    transform: "translate(1384.04 -4216.11)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_419",
    "data-name": "Path 419",
    className: "cls-2",
    d: "M-1198.68,4373.32a17.37,17.37,0,0,1,15.62,9.65l6.82,13.64h6.17l-7.44-25.91a11.65,11.65,0,0,1,8-14.4,11.63,11.63,0,0,1,3.21-.45h11.5a5.83,5.83,0,0,0,3.64-1.28l19-15.2a5.81,5.81,0,0,0,1.7-6.81l-10-23.29a17.56,17.56,0,0,1,7.07-21.86l14.64-8.81a5.79,5.79,0,0,0,2.83-5.05l-.07-5.93a128.4,128.4,0,0,0-91.77,105.7Z",
    transform: "translate(1384.04 -4216.11)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImg4);
export default __webpack_public_path__ + "static/media/img-4.4b6ad3e3506d097be3ce86c9bf60cbbb.svg";
export { ForwardRef as ReactComponent };